__turbopack_context__.v({
  "contentContainer": "ProductCard-module-scss-module__9Mgx0W__contentContainer",
  "image": "ProductCard-module-scss-module__9Mgx0W__image",
  "name": "ProductCard-module-scss-module__9Mgx0W__name",
  "originalPrice": "ProductCard-module-scss-module__9Mgx0W__originalPrice",
  "price": "ProductCard-module-scss-module__9Mgx0W__price",
  "productCard": "ProductCard-module-scss-module__9Mgx0W__productCard",
  "reviewTotal": "ProductCard-module-scss-module__9Mgx0W__reviewTotal",
  "salePrice": "ProductCard-module-scss-module__9Mgx0W__salePrice",
});
